import { UserMenu } from './auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { useI18n } from '../contexts/I18nContext';

function LogoOrdnr() {
  return (
    <div className="h-16 relative shrink-0" data-name="Logo-Ordnr">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1912 883" fill="none" preserveAspectRatio="xMidYMid meet" aria-hidden="true" role="img">
        <path d="M597.09 662.31V330.72H756.53V381.22H655.53V662.31H597.09Z" fill="currentColor"/>
        <path d="M792.03 496.51C792.03 472.58 794.73 449.98 800.14 428.7C805.55 407.42 813.66 389 824.47 373.43C835.28 357.87 848.96 345.54 865.5 336.43C882.04 327.33 901.34 322.77 923.4 322.77C948.12 322.77 969.37 328.07 987.12 338.65C1004.88 349.24 1018.93 364.59 1029.29 384.7V219.86H1087.73V662.3H1029.29V608.3C1018.93 628.21 1005.09 643.5 987.76 654.19C970.43 664.88 949.5 670.23 924.98 670.23C902.5 670.23 882.94 665.67 866.3 656.57C849.65 647.47 835.82 635.08 824.79 619.41C813.76 603.74 805.55 585.37 800.14 564.3C794.73 543.23 792.03 520.63 792.03 496.49V496.51ZM853.96 547.96C853.96 559.19 856.12 569.45 860.46 578.77C864.79 588.09 870.76 595.97 878.38 602.43C885.99 608.89 894.87 613.97 905.01 617.68C915.15 621.38 926.36 623.24 938.62 623.24C968 623.24 990.46 613.92 1005.99 595.29C1021.52 576.66 1029.3 553.05 1029.3 524.46V468.56C1029.3 439.97 1021.53 416.31 1005.99 397.57C990.46 378.83 968 369.46 938.62 369.46C926.57 369.46 915.42 371.31 905.17 375.02C894.92 378.72 885.99 383.86 878.38 390.42C870.77 396.99 864.8 404.93 860.46 414.24C856.13 423.56 853.96 433.83 853.96 445.05V547.96Z" fill="currentColor"/>
        <path d="M1532.56 662.31V330.72H1692V381.22H1591V662.31H1532.56Z" fill="currentColor"/>
        <path d="M223.27 386.01H278.32V606.89H223.27V386.01Z" fill="currentColor"/>
        <path d="M444.42 606.89V386H499.47V606.89H444.42Z" fill="currentColor"/>
        <path d="M278.56 385.75V330.71H444.18V385.75H278.56Z" fill="currentColor"/>
        <path d="M278.56 662.18V607.15H444.17V662.18H278.56Z" fill="currentColor"/>
        <path d="M1172.35 330.72H1227.47V385.86H1282.65V441.12C1278.04 441.14 1273.45 441.12 1268.87 441.13C1264.26 441.13 1259.66 441.13 1255.05 441.13H1241.4C1236.81 441.13 1232.22 441.13 1227.46 441.13V662.17H1172.34V330.71L1172.35 330.72Z" fill="currentColor"/>
        <path d="M1393.49 386H1448.56V661.99C1447.21 662.36 1395.17 662.4 1393.49 662.02V386Z" fill="currentColor"/>
        <path d="M1393.25 330.71V385.74H1282.92V330.71H1393.25Z" fill="currentColor"/>
      </svg>
    </div>
  );
}

function NavItem() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();
  const isActive = location.pathname === '/' || location.pathname === '/dashboard';

  return (
    <div 
      className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
      data-name="Nav-Item"
      onClick={() => navigate('/')}
    >
      <div className="nav-item-text">
        <p className="leading-normal whitespace-pre">{t('nav.dashboard')}</p>
      </div>
    </div>
  );
}

function NavItem1() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();
  const isActive = location.pathname === '/folders';

  return (
    <div 
      className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
      data-name="Nav-Item"
      onClick={() => navigate('/folders')}
    >
      <div className="nav-item-text">
        <p className="leading-normal whitespace-pre">{t('nav.folders')}</p>
      </div>
    </div>
  );
}

function NavItem2() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();
  const isActive = location.pathname === '/budget';

  return (
    <div 
      className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
      data-name="Nav-Item"
      onClick={() => navigate('/budget')}
    >
      <div className="nav-item-text">
        <p className="leading-normal whitespace-pre">{t('nav.budget')}</p>
      </div>
    </div>
  );
}


function NavItemContainer() {
  return (
    <div className="flex gap-4 h-full items-center justify-start relative shrink-0" data-name="nav-item-container">
      <NavItem />
      <NavItem1 />
      <NavItem2 />
    </div>
  );
}

function ButtonContainer() {
  return (
    <div className="flex gap-4 items-center justify-end relative shrink-0" data-name="Button-Container">
      <UserMenu />
    </div>
  );
}

function NavConentContainer() {
  return (
    <div className="nav-content-container" data-name="nav-conent-container">
      <LogoOrdnr />
      <div className="flex-1 flex justify-center">
        <NavItemContainer />
      </div>
      <ButtonContainer />
    </div>
  );
}

export default function Navigation() {
  return (
    <div className="navigation-container" data-name="Navigation">
      <div className="flex flex-col items-center justify-center relative w-full h-full">
        <div className="navigation-inner">
          <NavConentContainer />
        </div>
      </div>
    </div>
  );
}